<template>
    <ul>
        <li v-for="(record, idx) in value" class="clearfix" :key="idx">
            <input type="text" :value="record" @blur="setUrls(idx, $event.target.value)">
            <button type="button" class="profile-list-add-btn" @click="img_click(idx)">확인</button>
            <button type="button" class="profile-list-close-btn" @click="delUrls(idx)"><img src="../../assets/home/del.png" alt="X" title="X"></button>
        </li>
        <li class="clearfix">
            <input type="text" v-model="new_dr_intro_url" ref="new_url_input">
            <button type="button" class="profile-list-add-btn" @click="addUrls">추가</button>
        </li>
    </ul>
</template>

<script>
    import oh from '@/lib/object_helper'

  export default {
    name: 'dr_intro_url',
    props: ['value'],
    data () {
      return {
        new_dr_intro_url: ""
      }
    },
    computed: {
      // consults: {
      //     get () { return this.dr.consults.join(',') }, // 이건 쪼개서 가공하는 방식이 필요하다.
      //     set (value) { return this.dr.consults = value.trim().split(',') } // 이거 comma가 아닌경우 어떻게 하지?
      //   },
    },
    methods: {
      setUrls(idx, value) {
        let dr_intro_url = [...this.value];
        if(!value.trim()) {
          alert('빈값을 저장할 수 없습니다.');
        } else {
          dr_intro_url[idx] = value;
        }
        this.$emit('input', dr_intro_url);
      },
      addUrls() {
        let dr_intro_url = [...this.value]
        if (dr_intro_url.length >= 10) {
            alert('병원 이미지는 20장까지 업로드가 가능합니다.')
            this.new_dr_intro_url = '';
            return;
        } 

        if(!this.new_dr_intro_url.trim()){
          alert('소개 영상 링크(URL)을 입력해 주세요.');
          this.new_dr_intro_url = '';
          this.$refs.new_url_input.focus();
          return;
        } else if(!this.new_dr_intro_url.includes('http://') && !this.new_dr_intro_url.includes('https://') ) {
          alert('소개 영상 링크(URL)의 형식은 http:// 또는 https:// 로 시작해야 합니다.');
          this.$refs.new_url_input.focus();
          return;
        }
        
        dr_intro_url.push(this.new_dr_intro_url)
        this.new_dr_intro_url = ''
        this.$emit('input', dr_intro_url)
      },
      delUrls(idx) {
        let dr_intro_url = [...this.value]
        dr_intro_url.splice(idx, 1)
        this.$emit('input', dr_intro_url)
      },
      img_click(idx) { 
        let dr_intro_url = [...this.value]
        window.open(dr_intro_url[idx],"","width=800,height=600")
      },
    }
  }
</script>

<style scoped>

    li {height: 50px; margin-bottom: 10px;}
    li:last-child {margin-bottom: none;}

    input {
        height: 50px;
        padding: 0 20px;
        border: 1px solid #d2d2d2;
        box-sizing: border-box;
        font: 400 16px 'Noto Sans KR', sans-serif;
    }

    .profile-list-add-btn {
        color: #fff;
        width: 80px;
        background-color: #d8d8d8;
        font: 400 16px 'Noto Sans KR', sans-serif;
    }

    input {width: 80%;}
    li > input {width: 80%;}

    li > input,
    button {float: left;}

    li > button {
        width: 30px;
        height: 50px;
        padding: 0;
        border: none;
        cursor: pointer;
        margin-left: 10px;
        position: relative;
        background-color: transparent;
    }

</style>